/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */

export type AdminNotificationSeverityEnum = typeof AdminNotificationSeverityEnum[keyof typeof AdminNotificationSeverityEnum];


export const AdminNotificationSeverityEnum = {
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
} as const;
